import { UNBIND_INFO_UPDATE, UNBIND_ORIGIN_INFO_UPDATE } from '../mutationTypes';

const initState = {
  unbind_info: {},
  unbind_origin_info: {},
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [UNBIND_INFO_UPDATE](states, newValue = initState.unbind_info) {
    const unbind_info = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { unbind_info });
  },
  [UNBIND_ORIGIN_INFO_UPDATE](states, newValue = initState.unbind_origin_info) {
    const unbind_origin_info = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { unbind_origin_info });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
